// 데이터 검증 유틸리티 함수들

// 이메일 검증
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// 전화번호 검증 (한국) - 하이픈 포함 형식 필수
export const validatePhone = (phone) => {
  if (!phone || phone.trim() === '') return false;
  
  // 하이픈 포함 형식: 010-1234-5678 또는 010-123-4567
  const phoneRegex = /^01[0-9]-[0-9]{3,4}-[0-9]{4}$/;
  return phoneRegex.test(phone.replace(/\s/g, ''));
};

// 주민등록번호 형식 검증 (실시간 검증용) - 하이픈 포함 형식만 체크
export const validateResidentNumberFormat = (residentNumber) => {
  if (!residentNumber || residentNumber.trim() === '') return false;
  
  // 하이픈 포함 형식: 000000-0000000 (앞 6자리-뒤 7자리)
  const residentRegex = /^\d{6}-[1-4]\d{6}$/;
  return residentRegex.test(residentNumber);
};

// 주민등록번호 검증 - 하이픈 포함 형식만 체크 (체크섬 검증 제거)
export const validateResidentNumber = (residentNumber) => {
  if (!residentNumber || residentNumber.trim() === '') return false;
  
  // 하이픈 포함 형식: 000000-0000000 (앞 6자리-뒤 7자리)
  const residentRegex = /^\d{6}-[1-4]\d{6}$/;
  return residentRegex.test(residentNumber);
};

// 날짜 검증
export const validateDate = (date) => {
  const dateObj = new Date(date);
  return dateObj instanceof Date && !isNaN(dateObj);
};

// 미래 날짜 검증
export const validateFutureDate = (date) => {
  const dateObj = new Date(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return dateObj >= today;
};

// 과거 날짜 검증
export const validatePastDate = (date) => {
  const dateObj = new Date(date);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return dateObj <= today;
};

// 숫자 검증
export const validateNumber = (value, min = null, max = null) => {
  const num = parseFloat(value);
  if (isNaN(num)) return false;
  if (min !== null && num < min) return false;
  if (max !== null && num > max) return false;
  return true;
};

// 정수 검증
export const validateInteger = (value, min = null, max = null) => {
  const num = parseInt(value);
  if (isNaN(num) || !Number.isInteger(num)) return false;
  if (min !== null && num < min) return false;
  if (max !== null && num > max) return false;
  return true;
};

// 문자열 길이 검증
export const validateStringLength = (value, minLength = 0, maxLength = null) => {
  if (typeof value !== 'string') return false;
  if (value.length < minLength) return false;
  if (maxLength !== null && value.length > maxLength) return false;
  return true;
};

// 필수 필드 검증
export const validateRequired = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string' && value.trim() === '') return false;
  if (Array.isArray(value) && value.length === 0) return false;
  return true;
};

/**
 * 묘소 정보 — validateContractData에서 필수로 검증하는 필드(field_code).
 * 계약서 폼(ContractFormV5)의 필수 표시(*)와 동기화할 것.
 */
export const CONTRACT_REQUIRED_MAUSOLEUM_FIELD_CODES = [
  'member_number',
  'complex',
  'area',
  'row_number',
  'number',
  'area_size',
];

// 계약 데이터 검증
// export const validateContractData = (data) => {
//   const errors = {};

//   // 기본 정보 검증
//   if (!validateRequired(data.contract_date)) {
//     errors.contract_date = '기본정보 - 계약일은 필수입니다.';
//   } else if (!validateDate(data.contract_date)) {
//     errors.contract_date = '기본정보 - 유효한 날짜를 입력해주세요.';
//   }

//   if (!validateRequired(data.type)) {
//     errors.type = '기본정보 - 계약 구분은 필수입니다.';
//   }

//   // 사망자 정보 검증 ('예정지' 계약은 사망자 정보 선택사항)
//   const isReservedPlot = data.type === '예정지';
  
//   if (!isReservedPlot) {
//     // 일반 계약: 사망자 정보 필수
//   if (!data.dead || !Array.isArray(data.dead) || data.dead.length === 0) {
//     errors.dead = '사망자정보 - 사망자 정보는 필수입니다.';
//   } else {
//     data.dead.forEach((dead, index) => {
//       if (!validateRequired(dead.name)) {
//         errors[`dead.${index}.name`] = `사망자정보 - 사망자 ${index + 1}의 이름은 필수입니다.`;
//       }
//       // 사망일은 선택사항이지만, 입력된 경우 유효한 날짜 형식인지 검증
//       if (dead.death_date && dead.death_date.trim() !== '' && !validateDate(dead.death_date)) {
//         errors[`dead.${index}.death_date`] = `사망자정보 - 사망자 ${index + 1}의 유효한 사망일을 입력해주세요.`;
//       }
//       // 설묘일(report_date)도 선택사항이지만, 입력된 경우 유효한 날짜 형식인지 검증
//       if (dead.report_date && dead.report_date.trim() !== '' && !validateDate(dead.report_date)) {
//         errors[`dead.${index}.report_date`] = `사망자정보 - 사망자 ${index + 1}의 유효한 설묘일을 입력해주세요.`;
//         }
//       });
//     }
//   } else if (data.dead && Array.isArray(data.dead) && data.dead.length > 0) {
//     // '예정지' 계약: 사망자 정보 선택사항이지만, 입력된 경우 검증
//     data.dead.forEach((dead, index) => {
//       // 이름이 입력된 경우에만 검증
//       if (dead.name && dead.name.trim() !== '') {
//         if (dead.death_date && dead.death_date.trim() !== '' && !validateDate(dead.death_date)) {
//           errors[`dead.${index}.death_date`] = `사망자정보 - 사망자 ${index + 1}의 유효한 사망일을 입력해주세요.`;
//         }
//         if (dead.report_date && dead.report_date.trim() !== '' && !validateDate(dead.report_date)) {
//           errors[`dead.${index}.report_date`] = `사망자정보 - 사망자 ${index + 1}의 유효한 설묘일을 입력해주세요.`;
//         }
//       }
//     });
//   }

//   // 묘소 정보 검증
//   if (!data.mausoleum) {
//     errors.mausoleum = '묘소정보 - 묘소 정보는 필수입니다.';
//   } else {
//     if (!validateRequired(data.mausoleum.member_number)) {
//       errors['mausoleum.member_number'] = '묘소정보 - 묘적 번호는 필수입니다.';
//     }
//     if (!validateRequired(data.mausoleum.complex)) {
//       errors['mausoleum.complex'] = '묘소정보 - 묘역(단지명)은 필수입니다.';
//     }
//     if (!validateRequired(data.mausoleum.area)) {
//       errors['mausoleum.area'] = '묘소정보 - 구역은 필수입니다.';
//     }
//     if (!validateRequired(data.mausoleum.row_number)) {
//       errors['mausoleum.row_number'] = '묘소정보 - 행번호는 필수입니다.';
//     }
//     if (!validateRequired(data.mausoleum.number)) {
//       errors['mausoleum.number'] = '묘소정보 - 번호는 필수입니다.';
//     }
//     if (!validateNumber(data.mausoleum.area_size, 0)) {
//       errors['mausoleum.area_size'] = '묘소정보 - 유효한 크기(평)를 입력해주세요.';
//     }
//   }

//   // 연고자 정보 검증
//   if (!data.acquaintances || !Array.isArray(data.acquaintances) || data.acquaintances.length === 0) {
//     errors.acquaintances = '연고자정보 - 연고자 정보는 필수입니다.';
//   } else {
//     data.acquaintances.forEach((acquaintance, index) => {
//       if (!validateRequired(acquaintance.name)) {
//         errors[`acquaintances.${index}.name`] = `연고자정보 - 연고자 ${index + 1}의 이름은 필수입니다.`;
//       }
//       if (!validateRequired(acquaintance.phone)) {
//         errors[`acquaintances.${index}.phone`] = `연고자정보 - 연고자 ${index + 1}의 연락처는 필수입니다.`;
//       } else if (!validatePhone(acquaintance.phone)) {
//         errors[`acquaintances.${index}.phone`] = `연고자정보 - 연고자 ${index + 1}의 유효한 연락처를 입력해주세요. (예: 010-1234-5678)`;
//       }
//       // 지번(address) 또는 도로명(road_address) 중 하나 — 마이그레이션·도로명만 입력된 계약 허용
//       if (
//         !validateRequired(acquaintance.address) &&
//         !validateRequired(acquaintance.road_address)
//       ) {
//         errors[`acquaintances.${index}.address`] = `연고자정보 - 연고자 ${index + 1}의 주소는 필수입니다.`;
//       }
//     });
//   }

//   return {
//     isValid: Object.keys(errors).length === 0,
//     errors
//   };
// };

// 비용 데이터 검증
// export const validateCostData = (data) => {
//   const errors = {};

//   if (!validateRequired(data.type)) {
//     errors.type = '비용 종류는 필수입니다.';
//   }

//   if (!validateNumber(data.amount, 0)) {
//     errors.amount = '유효한 금액을 입력해주세요.';
//   }

//   if (!validateRequired(data.due_date)) {
//     errors.due_date = '납부기한은 필수입니다.';
//   } else if (!validateDate(data.due_date)) {
//     errors.due_date = '유효한 날짜를 입력해주세요.';
//   }

//   return {
//     isValid: Object.keys(errors).length === 0,
//     errors
//   };
// };

// 관리비 데이터 검증
// export const validateManagementFeeData = (data) => {
//   const errors = {};

//   if (!validateRequired(data.period_start)) {
//     errors.period_start = '관리기간 시작일은 필수입니다.';
//   } else if (!validateDate(data.period_start)) {
//     errors.period_start = '유효한 날짜를 입력해주세요.';
//   }

//   if (!validateRequired(data.period_end)) {
//     errors.period_end = '관리기간 종료일은 필수입니다.';
//   } else if (!validateDate(data.period_end)) {
//     errors.period_end = '유효한 날짜를 입력해주세요.';
//   }

//   if (!validateNumber(data.amount, 0)) {
//     errors.amount = '유효한 금액을 입력해주세요.';
//   }

//   if (!validateRequired(data.due_date)) {
//     errors.due_date = '납부기한은 필수입니다.';
//   } else if (!validateDate(data.due_date)) {
//     errors.due_date = '유효한 날짜를 입력해주세요.';
//   }

//   // 기간 검증
//   if (data.period_start && data.period_end) {
//     const startDate = new Date(data.period_start);
//     const endDate = new Date(data.period_end);
//     if (startDate >= endDate) {
//       errors.period_end = '종료일은 시작일보다 늦어야 합니다.';
//     }
//   }

//   return {
//     isValid: Object.keys(errors).length === 0,
//     errors
//   };
// };

// 보수 데이터 검증
// export const validateMaintenanceData = (data) => {
//   const errors = {};

//   if (!validateRequired(data.title)) {
//     errors.title = '보수 제목은 필수입니다.';
//   }

//   if (!validateRequired(data.description)) {
//     errors.description = '보수 내용은 필수입니다.';
//   }

//   if (!validateRequired(data.work_date)) {
//     errors.work_date = '작업일은 필수입니다.';
//   } else if (!validateDate(data.work_date)) {
//     errors.work_date = '유효한 날짜를 입력해주세요.';
//   }

//   if (!validateNumber(data.cost, 0)) {
//     errors.cost = '유효한 비용을 입력해주세요.';
//   }

//   return {
//     isValid: Object.keys(errors).length === 0,
//     errors
//   };
// };

// 사용자 데이터 검증
// export const validateUserData = (data) => {
//   const errors = {};

//   if (!validateRequired(data.name)) {
//     errors.name = '이름은 필수입니다.';
//   }

//   if (!validateRequired(data.email)) {
//     errors.email = '이메일은 필수입니다.';
//   } else if (!validateEmail(data.email)) {
//     errors.email = '유효한 이메일을 입력해주세요.';
//   }

//   if (!validateRequired(data.phone)) {
//     errors.phone = '연락처는 필수입니다.';
//   } else if (!validatePhone(data.phone)) {
//     errors.phone = '유효한 연락처를 입력해주세요.';
//   }

//   if (!validateRequired(data.role)) {
//     errors.role = '역할은 필수입니다.';
//   }

//   return {
//     isValid: Object.keys(errors).length === 0,
//     errors
//   };
// };

// 묘지 데이터 검증
// export const validateCemeteryData = (data) => {
//   const errors = {};

//   if (!validateRequired(data.name)) {
//     errors.name = '묘지명은 필수입니다.';
//   }

//   if (!validateRequired(data.address)) {
//     errors.address = '주소는 필수입니다.';
//   }

//   if (!validateNumber(data.capacity, 1)) {
//     errors.capacity = '유효한 수용 인원을 입력해주세요.';
//   }

//   return {
//     isValid: Object.keys(errors).length === 0,
//     errors
//   };
// };

// 에러 메시지 포맷팅
export const formatValidationErrors = (errors) => {
  return Object.values(errors).join('\n');
};

// 필드별 에러 메시지 가져오기
export const getFieldError = (errors, fieldPath) => {
  return errors[fieldPath] || '';
};

// 중첩된 필드 에러 메시지 가져오기
export const getNestedFieldError = (errors, fieldPath) => {
  const keys = fieldPath.split('.');
  let current = errors;
  
  for (const key of keys) {
    if (current && typeof current === 'object' && key in current) {
      current = current[key];
    } else {
      return '';
    }
  }
  
  return typeof current === 'string' ? current : '';
}; 